export enum Overflow {
    visible,
    hidden,
    scroll,
    auto,
    inherit
}